import React, { useState, useEffect } from "react";
import {
    Collapse, Form, Input, Select
} from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
// import globalData from "../../config/global_data";
const { Panel } = Collapse;

const VariationDetails = ({variantoption, setSavedVariantOptions, variant_detils=null }) => {

    const [variantOptions, setVariantOptions] = useState(null);
    const [selected_type, setSelected_type]= useState("")
     useEffect(() => {
        
        if(variantoption && variantoption.variant_options && variantoption.variant_options.length>0){
            setVariantOptions(variantoption.variant_options[0])   
            setSelected_type(variantoption.variant_options[0].type) 
            setSavedVariantOptions(variantoption.variant_options[0]) 
        }
        if(variant_detils){
            setVariantOptions({display_name: variant_detils.name})   
            setSelected_type(variant_detils.type)
            if( variant_detils){
                setSavedVariantOptions({
                    option_display_name:   variant_detils.name,
                    type: variant_detils.type
                }) 
            }

        }
            // id: vari
     }, [variantoption])

    const panelItems = variantOptions
        ? [
              {
                  key: "1",
                  label: "Variation Details",
                  children: (
                      <>
                          <Form.Item
                              label={
                                  <span>
                                      Variation Name&nbsp;
                                      {/* <QuestionCircleOutlined
                                          style={{ color: "rgba(0, 0, 0, 0.45)", cursor: "pointer" }}
                                          title="This is the Variation Name."
                                      /> */}
                                  </span>
                              }
                              initialValue=""
                          >
                              <Input placeholder="Enter a Variation Name" value={variantOptions.display_name} onChange={e=>{
                                  setVariantOptions({...variantOptions,display_name: e.target.value})
                                  setSavedVariantOptions(variantOptions) 
                              }}/>
                          </Form.Item>
                          <Form.Item
                              label={
                                  <span>
                                      Variation Display&nbsp;
                                      {/* <QuestionCircleOutlined
                                          style={{ color: "rgba(0, 0, 0, 0.45)", cursor: "pointer" }}
                                          title="This is the Variation Display."
                                      /> */}
                                  </span>
                              }
                          >
                              <Select placeholder="Select Option" value={selected_type} disabled>
                                  <Select.Option value="swatch">Swatch</Select.Option>
                                  <Select.Option value="radioButton">Radio Button</Select.Option>
                                  <Select.Option value="rectangles">Rectangle List</Select.Option>
                                  <Select.Option value="dropdown">Dropdown</Select.Option>
                              </Select>
                          </Form.Item>
                      </>
                  )
              }
          ]
        : [];

    return (
        <Collapse className="ProductDetailsCollapse" style={{ marginBottom: 16 , marginTop: 16 }} items={panelItems} />
    );
};

export default VariationDetails;
